export const optionalValidationParams = (validate?: boolean): URLSearchParams | undefined =>
  validate? new URLSearchParams(`validate=${validate}`) : undefined;
